import {
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Full Name
        </InputLabel>
        <TextField
          variant="outlined"
          name="driverName"
          value={filterData.driverName}
          onChange={handleChangeFilter("driverName")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          User Name
        </InputLabel>
        <TextField
          variant="outlined"
          name="userName"
          value={filterData.userName}
          onChange={handleChangeFilter("userName")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Status
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.active}
            onChange={(e) => handleChangeFilter("active")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{
              marginRight: 2,
              textTransform: "none",
              color: "#48505E",
              borderColor: "#E0E0E0",
            }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            onClick={handleFilter}
            endIcon={<ArrowForward />}
            sx={{
              backgroundColor: "#7152F3",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#5c34fa",
              },
            }}
          >
            Filter
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
